import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import TableComponent from "../common/TableComponent";

import {
  AddDirector,
  AddEngineer,
  AddProducer,
  AddAgent,
  AddRecordingStudio,
  AddVoiceTalent,
  DeleteDirector,
  DeleteEngineer,
  DeleteProducer,
  DeleteAgent,
  DeleteRecordingStudio,
  DeleteVoiceTalent,
  getDirector,
  getDirectorByEdit,
  getAgent,
  getAgentByEdit,
  getEngineer,
  getEngineerByEdit,
  getProducer,
  getProducerByEdit,
  getRecordingStudioByEdit,
  getRecordingstudio,
  getVoiceTalent,
  getVoiceTalentByEdit,
} from "../../api";
import { specialitySchema } from "../../schema";

const initialValues = {
  specialities: "",
};

const Specialities = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [currentUserType, setCurrentUserType] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [allUserData, setAllUserData] = useState("");
  const [allFilterData, setAllFilterData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [currentElementId, setCurrentElementId] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [blankErr, setBlankErr] = useState(false);

  // const tableColumnTitles = ["Sr.no", "UserType", "Name", "Action"];
  const tableColumnTitles = [
    {
      name: "Sr.No",
      // field: "Sr.No",
      isSortFilter: false,
      isAction: true,
    },
    {
      name: "UserType",
      // field: "UserType",
      isSortFilter: false,
      isAction: false,
    },
    {
      name: "Name",
      field: "Name",
      isSortFilter: true,
      isAction: false,
    },
    { name: "Action", isSortFilter: false, isAction: true },
  ];

  const { values, errors, handleSubmit, touched, setFieldValue, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: specialitySchema(),
      onSubmit: (values, action) => onSubmitHandler(values, action),
    });

  const toast = useRef(null);

  const getVoiceTalentData = async () => {
    getVoiceTalent(token)
      .then((res) => {
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        // setFieldValue("special", arr);
      })
      .catch((err) => {});
  };

  const getAgentData = async () => {
    getAgent(token)
      .then((res) => {
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
      })
      .catch((err) => {});
  };

  const getProducerData = async () => {
    getProducer(token)
      .then((res) => {
        let arr = [];
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        // setFieldValue("special", arr);
      })
      .catch((err) => {});
  };

  const getDirectorData = async () => {
    getDirector(token)
      .then((res) => {
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        // setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getEngineerData = async () => {
    getEngineer(token)
      .then((res) => {
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        // setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getRecordingStudioData = async () => {
    getRecordingstudio(token)
      .then((res) => {
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
      })
      .catch((err) => {});
  };

  const onUserTypeChangeHandler = async (val) => {
    setFieldValue("specialities", "");
    setIsEdit(false);
    setCurrentUserType(val);
    switch (val) {
      case "voicetalent":
        await getVoiceTalentData();
        break;
      case "agent":
        await getAgentData();
        break;
      case "producer":
        await getProducerData();
        break;
      case "director":
        await getDirectorData();
        break;
      case "engineer":
        await getEngineerData();
        break;
      case "recordingstudio":
        await getRecordingStudioData();
        break;
      default:
        break;
    }
  };

  // Filtering
  const updateResponseData = (searchData) => {
    searchData.map((ele) => {
      if (ele.searchField !== "") {
        if (ele?.searchValue !== "") {
          switch (ele.searchField) {
            // case "Sr No":
            //   const dataSrNo = allFilterData.filter((item) =>
            //     item?.index + 1?.includes(ele.searchValue)
            //   );
            //   setAllNewsData(dataSrNo);
            //   break;
            case "Name":
              const dataName = allFilterData.filter((item) =>
                item?.name_en
                  ?.toLowerCase()
                  ?.includes(ele.searchValue?.toLowerCase())
              );
              setAllUserData(dataName);
              break;
            default:
              break;
          }
        } else {
          setAllUserData(allFilterData);
        }
      }
      return "";
    });
  };

  // --------------------------------------------------------------------------------------------------------------------------------------------------
  //   Add

  const onChangeHandler = (e) => {
    setBlankErr(false);
    setFieldValue("specialities", e);
  };
  const onSubmitHandler = async (values, action) => {
    if (values.specialities.trim() === "") {
      setBlankErr(true);
      return;
    }
    if (!blankErr) {
      const reqobj = {
        name_en: values.specialities.trim(),
        name_es: values.specialities.trim(),
        name_fr: values.specialities.trim(),
      };
      if (isEdit) {
        switch (currentUserType) {
          case "voicetalent":
            try {
              const response = await getVoiceTalentByEdit(
                currentElementId,
                reqobj,
                token
              );
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
                setIsEdit(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "producer":
            try {
              const response = await getProducerByEdit(
                currentElementId,
                reqobj,
                token
              );
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsEdit(false);
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "agent":
            try {
              const response = await getAgentByEdit(
                currentElementId,
                reqobj,
                token
              );
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsEdit(false);
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "director":
            try {
              const response = await getDirectorByEdit(
                currentElementId,
                reqobj,
                token
              );
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsEdit(false);
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "engineer":
            try {
              const response = await getEngineerByEdit(
                currentElementId,
                reqobj,
                token
              );
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsEdit(false);
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "recordingstudio":
            try {
              const response = await getRecordingStudioByEdit(
                currentElementId,
                reqobj,
                token
              );
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsEdit(false);
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          default:
            // Handle the default case
            break;
        }
        // Edit
      } else {
        switch (currentUserType) {
          case "voicetalent":
            try {
              const res = await AddVoiceTalent(reqobj, token);
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${res?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "producer":
            try {
              const response = await AddProducer(reqobj, token);
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "agent":
            try {
              const response = await AddAgent(reqobj, token);
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "director":
            try {
              const resp = await AddDirector(reqobj, token);
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${resp?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "engineer":
            try {
              const response = await AddEngineer(reqobj, token);
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${response?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          case "recordingstudio":
            try {
              const res = await AddRecordingStudio(reqobj, token);
              setIsLoading(true);
              action.resetForm();
              toast.current.show({
                severity: "success",
                summary: `${res?.data?.message}`,
              });
              onUserTypeChangeHandler(currentUserType);
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            } catch (error) {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: `${error?.response?.data?.message}`,
              });
            }
            break;
          default:
            // Handle the default case
            break;
        }
      }
    }
  };

  // --------------------------------------------------------------------------------------------------------------------------------------------------
  //   Edit

  const editUserHandler = (ele) => {
    setFieldValue("specialities", ele.name_en);
    setIsEdit(true);
    setCurrentElementId(ele.id);
  };

  // --------------------------------------------------------------------------------------------------------------------------------------------------
  //   delete

  const deleteUserHandler = async (id) => {
    const handleDeleteUser = async (apiFunction, currentUserType) => {
      try {
        const res = await apiFunction(id, token);
        setIsLoading(true);
        setShow(false);
        setDeleteId(null);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        onUserTypeChangeHandler(currentUserType);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } catch (err) {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      }
    };

    switch (currentUserType) {
      case "voicetalent":
        await handleDeleteUser(DeleteVoiceTalent, currentUserType);
        break;
      case "producer":
        await handleDeleteUser(DeleteProducer, currentUserType);
        break;
      case "agent":
        await handleDeleteUser(DeleteAgent, currentUserType);
        break;
      case "director":
        await handleDeleteUser(DeleteDirector, currentUserType);
        break;
      case "engineer":
        await handleDeleteUser(DeleteEngineer, currentUserType);
        break;
      case "recordingstudio":
        await handleDeleteUser(DeleteRecordingStudio, currentUserType);
        break;
      default:
        break;
    }
  };

  // --------------------------------------------------------------------------------------------------------------------------------------------------

  const adminTableRequests = (ele, index) => {
    return (
      <>
        <tr key={index} className="table-light">
          <td>{index + 1}</td>
          <td>{currentUserType}</td>
          <td>{ele?.name_en ? ele?.name_en : "-"}</td>
          <td>
            <Link
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="#none"
                className="bi bi-pencil-square mx-2 ms-0"
                viewBox="0 0 16 16"
                onClick={() => editUserHandler(ele)}
              >
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path
                  fillRule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            </Link>
            <Link
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
              onClick={() => {
                setDeleteId(ele.id);
                setShow(true);
              }}
            >
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.5 0.25H5.5V1.5H10.5V0.25ZM0.5 2.75V4H1.75V16.5C1.75 17.1904 2.30964 17.75 3 17.75H13C13.6904 17.75 14.25 17.1904 14.25 16.5V4H15.5V2.75H0.5ZM3 16.5V4H13V16.5H3ZM5.5 6.5H6.75V14H5.5V6.5ZM10.5 6.5H9.25V14H10.5V6.5Z"
                  fill="#212121"
                />
              </svg>
            </Link>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />

      {show && (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="logout-modal"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-title text-center">
            Are you sure you want to delete this Speciality?
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center">
            <Button
              variant="secondary"
              className="me-3 yes-btn-cls-add"
              onClick={() => {
                deleteUserHandler(deleteId);
                // onUserTypeChangeHandler();
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="no-btn-cls-add"
              onClick={() => {
                setDeleteId(null);
                setShow(false);
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="content-section badges-section upload-user-profile-cls role-management-cls-adding-proper">
        <div className="specialities-tabbing">
          <h6>Specialities Type Details</h6>
          <hr />

          <div className="user-type-details mb-3 mt-3">
            <form onSubmit={handleSubmit} className="">
              <div className="start-here-code">
                <div className="form-all-here-start">
                  <div className="row my-4">
                    <div className="col-lg-4">
                      <label className="my-2">Select User Type</label>
                      <select
                        value={currentUserType}
                        className="form-select"
                        aria-label="Default select example"
                        // onBlur={handleBlur}
                        onChange={(e) =>
                          onUserTypeChangeHandler(e.target.value)
                        }
                      >
                        <option value="" disabled hidden>
                          Select User types
                        </option>
                        <option value="voicetalent" label="Voicetalent">
                          Voice-talent
                        </option>
                        <option value="producer" label="Producer">
                          Producer
                        </option>
                        <option value="director" label="Director">
                          Director
                        </option>
                        <option value="agent" label="Agent">
                          Agent
                        </option>
                        <option value="engineer" label="Engineer">
                          Engineer
                        </option>
                        <option value="recordingstudio" label="Recordingstudio">
                          Recording-studio
                        </option>
                      </select>
                      {/* {errors.user_type && touched.user_type ? (
                        <p className="form-error">{errors.user_type}</p>
                      ) : null} */}
                    </div>
                  </div>
                  {currentUserType !== "" && (
                    <div className="row my-4">
                      <div className="col-lg-4">
                        <label className="my-2">Add Specialities</label>
                        <input
                          type="text"
                          className="form-control"
                          name="specialities"
                          value={values.specialities}
                          onChange={(e) => onChangeHandler(e.target.value)}
                          onBlur={handleBlur}
                          id="exampleFormControlInput2"
                          placeholder="Enter Your Speciality Name"
                        />
                        {errors.specialities && touched.specialities ? (
                          <p className="form-error">{errors.specialities}</p>
                        ) : null}
                        {blankErr && (
                          <p className="form-error">White-space not allowed</p>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <div className="event-details-btn-cls right-side-btn-add edit-btn-only-this-add-for">
                          <button
                            type="submit"
                            className="btn btn-primary edit-btn-cls"
                          >
                            {isEdit ? "Edit" : "Add"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {currentUserType !== "" && (
                  <div className="table-cls-portion mt-5">
                    <TableComponent
                      tableColumnTitles={tableColumnTitles}
                      tabRequests={allUserData}
                      tableRowRequests={adminTableRequests}
                      updateResponseData={updateResponseData}
                    />
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Specialities;
